import React from "react";
import { Routes, Route} from 'react-router-dom';
import Home from "./components/Home";
import About from "./components/About";
import ServicesUpdated from "./components/ServicesUpdated";


function App() {
  return (
    <Routes>
      <Route path='/' element={<Home />}></Route>
      <Route path='/about-us' element={<About />}></Route>
      <Route path='/services' element={<ServicesUpdated />}></Route>
    </Routes>
  );
}

export default App;
